import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { cn } from '../../utils/cn';
interface AccordionItemProps {
  title: string;
  children: React.ReactNode;
  isOpen?: boolean;
  onClick?: () => void;
}
export function AccordionItem({
  title,
  children,
  isOpen,
  onClick
}: AccordionItemProps) {
  return <div className="border-b border-stone-200 last:border-0" data-id="element-231">
      <button className="flex w-full items-center justify-between py-4 text-left font-medium text-stone-900 transition-all hover:text-emerald-700" onClick={onClick} data-id="element-232">
        <span className="text-lg" data-id="element-233">{title}</span>
        <ChevronDownIcon className={cn('h-5 w-5 text-stone-500 transition-transform duration-200', isOpen && 'rotate-180 text-emerald-700')} data-id="element-234" />
      </button>
      <div className={cn('overflow-hidden transition-all duration-300 ease-in-out', isOpen ? 'max-h-96 opacity-100 pb-4' : 'max-h-0 opacity-0')} data-id="element-235">
        <div className="text-stone-600 leading-relaxed" data-id="element-236">{children}</div>
      </div>
    </div>;
}
export function Accordion({
  children,
  className
}: {
  children: React.ReactNode;
  className?: string;
}) {
  return <div className={cn('divide-y divide-stone-200 rounded-xl border border-stone-200 bg-white px-6', className)} data-id="element-237">
      {children}
    </div>;
}